import React, { useState } from "react";
import "../assets/css/mobileHeader.css";
import img from "../assets/images/hero.png";
import useWidth from "../hooks/useWidth";
import logo from "../assets/images/logo/logo.png";
import circle from "../assets/images/circle.svg";
import profile from '../assets/images/mobilefooter/profile.png'
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoginPopup from "../components/LoginPopup";

const MobileHeader = ({ himage = img, height = '355' , gradient=false, children } ) => {
  const width = useWidth();
  const [modal, setModal] = useState({ open: false });

  const imgDisplay = gradient ? 'none' : ""


  const isLoggedIn = useSelector( state => state.auth.isLoggedIn )
  const navigate = useNavigate()

  const handleLogin = () => {
      if( isLoggedIn ){
        navigate('/user')
        return
      }
      setModal({ open: true })
  }

  return (
    <div className={`mobile-header gradient`} style={{background:"#fff", height:height}}>
      <img
        src={himage}
        className="mobile-header-img h-100"
        alt=""
        style={{ width: width, display:imgDisplay }}
      />
      <div className="header-main-content  d-flex flex-column justify-content-between">
        <div className="d-flex  justify-content-between align-items-center px-3 py-4">
          <Link to={'/'} className="mobile-logo-container">
            <img src={logo} alt="" className="w-100 h-100" />
          </Link>
          <div onClick={() => handleLogin()} >
            <div className="basket p-1" >
                <img src={profile} alt="" className="basket-img" />
            </div>
          </div>
        </div>
        <div className="mt-1 pb-3 w-100 d-flex justify-content-center align-items-end">
              {children}
        </div>
       
      </div>

      {modal.open && <LoginPopup open={modal.open} setOpen={setModal} />}

    </div>
  );
};

export default MobileHeader;




 